import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const Section = styled('section')`
  position: relative;
  color: ${({ theme }) => theme.color.white};

  background-color: ${({ theme }) => theme.color.noir};
  padding: ${({ theme }) => theme.x2space}rem;
  margin-bottom: ${({ theme }) => theme.x2space}rem;

  ${media.mdUp`
    padding: ${({ theme }) => theme.x4space}rem;
  `}

  ${media.lgUp`
  border-radius: 8px;
  `}

  @media print {
    break-inside: avoid;
  }
`;
